(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientGroupDeleteController',PatientGroupDeleteController);

    PatientGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientGroup'];

    function PatientGroupDeleteController($uibModalInstance, entity, PatientGroup) {
        var vm = this;

        vm.patientGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
